import { render, staticRenderFns } from "./AdPublishDialog.vue?vue&type=template&id=5387333a&scoped=true"
import script from "./AdPublishDialog.vue?vue&type=script&lang=js"
export * from "./AdPublishDialog.vue?vue&type=script&lang=js"
import style0 from "./AdPublishDialog.vue?vue&type=style&index=0&id=5387333a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5387333a",
  null
  
)

export default component.exports